/* 项目详情 */
export const pmObject = `query pmObject($id: ID! = 1){
  pmObject(id: $id){
    id
    logo{
      url
    }
    objectName
    objectSubtitle
    objectIntroduction
    about
    videoUrl
    videoDesc
    topImg{
      url
    }
    botImg{
      url
    }
    videoBackground{
      url
    }
    bannerImg{
		  url
    }
    webbannerItems{
      lab
      num
      icon{
        url
      }
    }
    bannerColor
    pmSimpleModule{
      title
      enTitle
      desc
      itemsInfo{
        lab
        num
        icon{
          url
        }
      }
    }
    platColor
    platIsOpen
    platTitle
    platSubTitle
    platEnTitle
    playBgImg{
      url
    }
    plateform{
      title
      subtitle
      icon{
        url
      }
      rwm{
        url
      }
      LableTree{
        id
        title
        subtitle
        icon{
          url
        }
        content{
          id
          title
          url
          subTitle
          file{
            url
          }
        }
      }
    }
    modular{
      id
      title
      subTitle
      bgColor
      bgImg{
        url
      }
      file{
        url
      }
      url
    }
    program{
      title
      subTitle
      desc
      AboutImage{
        id
        title
        about
        image{
        url
      }
      }
      bgColor
      bgImg{
        url
      }
    }
    classTitle
    classEnTitle
    classList{
      id
      title
      subTitle
      desc
    }
    actionlabel
    actionImg{
      url
    }
    teachModleTitle
    TeachEnTitle
    teachBgColor
    teachBgImg{
      url
    }
    teacheres{
      id
      name
      quarters
      headerImage {
        url
      }
      details
      isPublic
      sortNum
    }
    teachBgColor
    teachBgImg{
        url
      }
  }
}`